import { Heart, Shield, Users, Award, Clock, Stethoscope, GraduationCap, Building } from "lucide-react";

export const stats = [
    { icon: Users, value: "50,000+", label: "Patients Treated Annually" },
    { icon: Stethoscope, value: "500+", label: "Expert Doctors" },
    { icon: Building, value: "30+", label: "Specialized Departments" },
    { icon: Clock, value: "29+", label: "Years of Excellence" },
  ];

export const values = [
    {
      icon: Heart,
      title: "Compassion",
      description: "We treat every patient with empathy, understanding, and genuine care, ensuring they feel supported throughout their healthcare journey."
    },
    {
      icon: Shield,
      title: "Integrity",
      description: "We uphold the highest ethical standards in all our practices, maintaining transparency and honesty in patient care and communication."
    },
    {
      icon: Award,
      title: "Excellence",
      description: "We strive for clinical excellence through continuous learning, research, and adoption of cutting-edge medical technologies."
    },
    {
      icon: Users,
      title: "Teamwork",
      description: "Our multidisciplinary teams collaborate seamlessly to provide comprehensive, patient-centered care for optimal outcomes."
    },
  ];

export const milestones = [
    { year: "1995", event: "Hospital Founded", description: "MediCare Hospital was established with a vision to provide world-class healthcare." },
    { year: "2000", event: "First Expansion", description: "Added 200 beds and opened 10 new specialized departments." },
    { year: "2008", event: "Research Center", description: "Launched our state-of-the-art medical research facility." },
    { year: "2015", event: "Digital Transformation", description: "Implemented advanced electronic health records and telemedicine services." },
    { year: "2020", event: "COVID-19 Response", description: "Established dedicated COVID care units and vaccination centers." },
    { year: "2024", event: "AI Integration", description: "Pioneered AI-assisted diagnostics and treatment planning." },
  ];

export const leadership = [
    { name: "Dr. Robert Johnson", role: "Chief Executive Officer", specialty: "Healthcare Administration" },
    { name: "Dr. Sarah Williams", role: "Chief Medical Officer", specialty: "Internal Medicine" },
    { name: "Dr. Michael Chen", role: "Chief of Surgery", specialty: "Cardiovascular Surgery" },
    { name: "Dr. Emily Davis", role: "Director of Research", specialty: "Medical Research" },
  ];


